import { render, staticRenderFns } from "./ClipboardElement.vue?vue&type=template&id=171cff28"
import script from "./ClipboardElement.vue?vue&type=script&lang=js"
export * from "./ClipboardElement.vue?vue&type=script&lang=js"
import style0 from "./ClipboardElement.vue?vue&type=style&index=0&id=171cff28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports